import React, { useState, useEffect, useRef } from 'react'
import styles from '../../../styles/UAEPageComponents.module.css'
import { Button } from 'reactstrap'
import Image from 'next/image'
import { NewMarqueeComponentHomePageIndia } from '@/components/qbStrap'
import VerificationPopupUAE from '@/components/HomeLanding/HomeLandingComponents/VerificationPopupUAE'
import { INDIA_COMPANY_LOGOS } from '@/constants/indiaCompanyLogos'
import { preloadImages } from '@/utils/preloadImages'

const HeaderSection = ( {data}) => {
    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!")
    const [isExpanded, setIsExpanded] = useState(false);
    const hasPlayedFloatingImagesRef = useRef(false);

    useEffect(() => {
        if (hasPlayedFloatingImagesRef.current) return;

        let cancelled = false;

        const initializeGSAP = async () => {
            if (typeof window === 'undefined') return;

            const images = data?.images || {};
            await preloadImages([
                images.mainImage?.src,
                images.img1?.src,
                images.img2?.src,
                images.img3?.src,
                images.img4?.src,
            ]);
            if (cancelled) return;

            const gsapModuleLoaded = await import('gsap');
            if (cancelled || hasPlayedFloatingImagesRef.current) return;
            const gsapInstance = gsapModuleLoaded.default;
            hasPlayedFloatingImagesRef.current = true;

            const floats = [
                [`.${styles.floatingImage1}`, 0.5],
                [`.${styles.floatingImage2}`, 0.8],
                [`.${styles.floatingImage3}`, 1.1],
                [`.${styles.floatingImage4}`, 1.4],
            ];

            floats.forEach(([selector, delay]) => {
                if (!document.querySelector(selector)) return;
                gsapInstance.fromTo(
                    selector,
                    { scale: 0 },
                    {
                        scale: 1,
                        duration: 0.5,
                        ease: "back.out(1.7)",
                        delay,
                        overwrite: "auto",
                    }
                );
            });
        };

        initializeGSAP();
        return () => {
            cancelled = true;
        };
    }, [data]);
    

   

    const UAECompanyLogos = [
        { imgSrc: "/assets/HomeLanding/CompanyIcon1.svg", height:"10rem",width:"15rem", altText: "CompanyIcon1" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon2.svg", height:"10rem",width:"15rem", altText: "CompanyIcon2" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon3.svg", height:"10rem",width:"15rem", altText: "CompanyIcon3" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon4.svg", height:"10rem",width:"15rem", altText: "CompanyIcon4" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon5.svg", height:"10rem",width:"15rem", altText: "CompanyIcon5" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon6.svg", height:"10rem",width:"15rem", altText: "CompanyIcon6" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon7.svg", height:"10rem",width:"15rem", altText: "CompanyIcon7" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon8.svg", height:"10rem",width:"15rem", altText: "CompanyIcon8" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon9.svg", height:"10rem",width:"15rem", altText: "CompanyIcon9" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon10.svg", height:"10rem",width:"15rem", altText: "CompanyIcon10" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon11.svg", height:"10rem",width:"15rem", altText: "CompanyIcon11" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon12.svg", height:"10rem",width:"15rem", altText: "CompanyIcon12" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon13.svg", height:"10rem",width:"15rem", altText: "CompanyIcon13" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon14.svg", height:"10rem",width:"15rem", altText: "CompanyIcon14" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon15.svg", height:"10rem",width:"15rem", altText: "CompanyIcon15" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon16.svg", height:"10rem",width:"15rem", altText: "CompanyIcon16" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon17.svg", height:"10rem",width:"15rem", altText: "CompanyIcon17" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon18.svg", height:"10rem",width:"15rem", altText: "CompanyIcon18" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon19.svg", height:"10rem",width:"15rem", altText: "CompanyIcon19" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon20.svg", height:"10rem",width:"15rem", altText: "CompanyIcon20" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon21.svg", height:"10rem",width:"15rem", altText: "CompanyIcon21" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon22.svg", height:"10rem",width:"15rem", altText: "CompanyIcon22" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon23.svg", height:"10rem",width:"15rem", altText: "CompanyIcon23" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon24.svg", height:"10rem",width:"15rem", altText: "CompanyIcon24" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon25.svg", height:"10rem",width:"15rem", altText: "CompanyIcon25" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon26.svg", height:"10rem",width:"15rem", altText: "CompanyIcon26" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon27.svg", height:"10rem",width:"15rem", altText: "CompanyIcon27" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon28.svg", height:"10rem",width:"15rem", altText: "CompanyIcon28" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon29.svg", height:"10rem",width:"15rem", altText: "CompanyIcon29" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon30.svg", height:"10rem",width:"15rem", altText: "CompanyIcon30" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon31.svg", height:"10rem",width:"15rem", altText: "CompanyIcon31" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon32.svg", height:"10rem",width:"15rem", altText: "CompanyIcon32" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon33.svg", height:"10rem",width:"15rem", altText: "CompanyIcon33" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon34.svg", height:"10rem",width:"15rem", altText: "CompanyIcon34" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon35.svg", height:"10rem",width:"15rem", altText: "CompanyIcon35" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon36.svg", height:"10rem",width:"15rem", altText: "CompanyIcon36" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon37.svg", height:"10rem",width:"15rem", altText: "CompanyIcon37" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon38.svg", height:"10rem",width:"15rem", altText: "CompanyIcon38" },
        { imgSrc: "/assets/HomeLanding/CompanyIcon39.svg", height:"10rem",width:"15rem", altText: "CompanyIcon39" },
        

    ]

    const CompanyLogos = data.useIndiaLogos ? INDIA_COMPANY_LOGOS : UAECompanyLogos;

    return (
        <>
               <div className={styles.headerMainSectionWrapper}>
            <div className={styles.headerSectionWrapper}>
                <div className={styles.verificationPopupOverride}>
                    {/* <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} /> */}
                    <VerificationPopupUAE isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
                </div>
                <div className={styles.headerSection}>
                    <div className={styles.dataContainer}>
                        <div className={styles.gradientSection}>
                            <div className={styles.gradientBlue}></div>
                            <div className={styles.gradientOrange}></div>
                        </div>

                        <div className={styles.contentWrapper}>
                            <div className={styles.textContainer}>
                                <div className={styles.textSection}>
                                    <h1 >
                                        <span className={styles.textSectionTitle}>{data.firstTitle}</span>
                                        <div className={styles.lineVector}>
                                            <Image
                                                src="/assets/UAERetailPage/LineVector.svg"
                                                alt="Line Vector"
                                                fill
                                            />
                                        </div>
                                        <span className={styles.textSectionSecondTitle}> <br /> {data.secondTitle}</span>
                                    </h1>
                                    <div>
                                        <p className={`${styles.descriptionText} ${!isExpanded ? styles.descriptionTextClamped : ''}`}>
                                            {data.description}
                                        </p>
                                        <button
                                            className={styles.readMoreBtn}
                                            onClick={() => setIsExpanded(!isExpanded)}
                                        >
                                            {isExpanded ? 'Read Less' : 'Read More'}
                                        </button>
                                    </div>
                                    <Button
                                        className={styles.demoButton}
                                        onClick={() => (setDemoModal(true), setHeading("Book your free demo now!"))}
                                    >
                                        <span>{data.ctaText || "Book a Free Demo"}</span>
                                    </Button>
                                </div>
                            </div>
                            <div className={styles.imageContainer}>
                                {data.images.bgVector && (
                                    <div className={styles.bgVector} style={{
                                        width: data.images.bgwidth,
                                        height: data.images.bgheight,
                                        top: data.images.bgtop,
                                        left: data.images.bgleft,
                                        bottom: data.images.bgbottom,
                                        right: data.images.bgright,
                                        zIndex: data.images.bgzindex
                                    }}>
                                        <Image src={data.images.bgVector} alt="Background Vector" fill />
                                    </div>
                                )}
                                <div className={styles.heroImage} style={{
                                    width: data.images.mainImage.width,
                                    height: data.images.mainImage.height,
                                    bottom: data.images.mainImage.bottom,
                                    right: data.images.mainImage.right
                                }}>
                                    <Image
                                        src={data.images.mainImage.src}
                                        alt={data.images.mainImage.alt}
                                        fill
                                        priority
                                    />
                                </div>
                                {data.images.img1 && (
                                    <div className={styles.floatingImage1} style={{
                                        width: data.images.img1.width,
                                        height: data.images.img1.height,
                                        top: data.images.img1.top,
                                        left: data.images.img1.left,
                                        bottom: data.images.img1.bottom,
                                        right: data.images.img1.right,
                                        zIndex: data.images.img1.zindex
                                    }}>
                                        <Image src={data.images.img1.src} alt={data.images.img1.alt} fill priority />
                                    </div>
                                )}
                                {data.images.img2 && (
                                    <div className={styles.floatingImage2} style={{
                                        width: data.images.img2.width,
                                        height: data.images.img2.height,
                                        top: data.images.img2.top,
                                        left: data.images.img2.left,
                                        bottom: data.images.img2.bottom,
                                        right: data.images.img2.right,
                                        zIndex: data.images.img2.zindex
                                    }}>
                                        <Image src={data.images.img2.src} alt={data.images.img2.alt} fill priority />
                                    </div>
                                )}
                                {data.images.img3 && (
                                    <div className={styles.floatingImage3} style={{
                                        width: data.images.img3.width,
                                        height: data.images.img3.height,
                                        top: data.images.img3.top,
                                        bottom: data.images.img3.bottom,
                                        left: data.images.img3.left,
                                        right: data.images.img3.right,
                                        zIndex: data.images.img3.zindex
                                    }}>
                                        <Image src={data.images.img3.src} alt={data.images.img3.alt} fill priority />
                                    </div>
                                )}
                                {data.images.img4 && (
                                    <div className={styles.floatingImage4} style={{
                                        width: data.images.img4.width,
                                        height: data.images.img4.height,
                                        top: data.images.img4.top,
                                        bottom: data.images.img4.bottom,
                                        left: data.images.img4.left,
                                        right: data.images.img4.right,
                                        zIndex: data.images.img4.zindex
                                    }}>
                                        <Image src={data.images.img4.src} alt={data.images.img4.alt} fill priority />
                                    </div>
                                )}
                                {data.images.strVector1 && (
                                    <div className={styles.vectorImage1} style={{
                                        width: data.images.strVector1.width,
                                        height: data.images.strVector1.height,
                                        top: data.images.strVector1.top,
                                        left: data.images.strVector1.left,
                                        bottom: data.images.strVector1.bottom,
                                        right: data.images.strVector1.right,
                                        zIndex: data.images.strVector1.zindex
                                    }}>
                                        <Image src={data.images.strVector1.src} alt={data.images.strVector1.alt} fill />
                                    </div>
                                )}
                                {data.images.strVector2 && (
                                    <div className={styles.vectorImage2} style={{
                                        width: data.images.strVector2.width,
                                        height: data.images.strVector2.height,
                                        top: data.images.strVector2.top,
                                        right: data.images.strVector2.right,
                                        bottom: data.images.strVector2.bottom,
                                        left: data.images.strVector2.left,
                                        zIndex: data.images.strVector2.zindex
                                    }}>
                                        <Image src={data.images.strVector2.src} alt={data.images.strVector2.alt} fill />
                                    </div>
                                )}
                                {data.images.strVector3 && (
                                    <div className={styles.vectorImage3} style={{
                                        width: data.images.strVector3.width,
                                        height: data.images.strVector3.height,
                                        bottom: data.images.strVector3.bottom,
                                        left: data.images.strVector3.left,
                                        right: data.images.strVector3.right,
                                        zIndex: data.images.strVector3.zindex
                                    }}>
                                        <Image src={data.images.strVector3.src} alt={data.images.strVector3.alt} fill />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>


            </div>
            </div>

            <div style={{ maxWidth: "1850px", margin: "0 auto" }}>
                <div style={{ margin: "0rem 18rem 0 18rem", position: "relative", zIndex: 1 }}>
                    <NewMarqueeComponentHomePageIndia
                        direction={'right'}
                        ClientsArr={CompanyLogos}
                        style={{
                            width: "100%",
                            backgroundColor: "transparent",
                            display: "flex",
                            justifyContent: "center",
                            margin: "2rem auto",
                        }}
                    />
                </div>
            </div>
        </>
    )
}

export default HeaderSection
